import service from "@/utils/request";

// 积分商品列表
export interface getIntegralGoodsListData {
  page?: number;
  page_size?: number;
  status?: number;
  goods_name?: string;
}
export const getIntegralGoodsListApi = (params: getIntegralGoodsListData) => {
  return service({
    url: "/api/v1/integral/goods/list",
    method: "get",
    params,
  });
};
// 积分商品详情
export interface getIntegralGoodsDetailData {
  goods_id: number;
}
export const getIntegralGoodsDetailApi = (
  params: getIntegralGoodsDetailData
) => {
  return service({
    url: "/api/v1/integral/goods/detail",
    method: "get",
    params,
  });
};
// 积分商品添加
export interface createIntegralGoodsData {
  goods_name: string;
  cover_image: string;
  stock: number;
  integral: number;
  status: number;
  sort?: number;
  remark?: string;
  description?: string;
}
export const createIntegralGoodsApi = (data: createIntegralGoodsData) => {
  return service({
    url: "/api/v1/integral/goods/add",
    method: "post",
    data,
  });
};
// 积分商品编辑
export interface editIntegralGoodsData {
  goods_id: number;
  goods_name: string;
  cover_image: string;
  stock: number;
  integral: number;
  status: number;
  sort?: number;
  remark?: string;
  description?: string;
}
export const editIntegralGoodsApi = (data: editIntegralGoodsData) => {
  return service({
    url: "/api/v1/integral/goods/edit",
    method: "post",
    data,
  });
};
// 积分商品排序
export interface sortIntegralGoodsData {
  goods_id: number;
  sort?: number;
}
export const sortIntegralGoodsApi = (data: sortIntegralGoodsData) => {
  return service({
    url: "/api/v1/integral/goods/edit_sort",
    method: "post",
    data,
  });
};
// 积分商品状态改变
export interface setIntegralGoodsStatusData {
  goods_id: number;
  status: number;
}
export const setIntegralGoodsStatusApi = (data: setIntegralGoodsStatusData) => {
  return service({
    url: "/api/v1/integral/goods/edit_status",
    method: "post",
    data,
  });
};
// 积分商品库存改变
export interface editIntegralGoodsStockData {
  goods_id: number;
  action_type: number;
  stock: number;
}
export const editIntegralGoodsStockApi = (data: editIntegralGoodsStockData) => {
  return service({
    url: "/api/v1/integral/goods/edit_stock",
    method: "post",
    data,
  });
};
// 积分商品删除
export interface deleteIntegralGoodsData {
  goods_id: number;
}
export const deleteIntegralGoodsApi = (data: deleteIntegralGoodsData) => {
  return service({
    url: "/api/v1/integral/goods/del",
    method: "post",
    data,
  });
};
// 积分商品兑换列表
export interface getExchangeListData {
  page: number;
  page_size: number;
  student_id?: number;
  goods_id?: number;
  status?: number;
}
export const getExchangeListApi = (params: getExchangeListData) => {
  return service({
    url: "/api/v1/integral/exchange_order/list",
    method: "get",
    params,
  });
};
// 积分商品兑换详情
export interface getExchangeDetailData {
  order_id: number;
}
export const getExchangeDetailApi = (params: getExchangeDetailData) => {
  return service({
    url: "/api/v1/integral/exchange_order/detail",
    method: "get",
    params,
  });
};
// 同意兑换
export interface agreeExchangeData {
  order_id: number;
}
export const agreeExchangeApi = (data: agreeExchangeData) => {
  return service({
    url: "/api/v1/integral/exchange_order/agree",
    method: "post",
    data,
  });
};
// 取消兑换
export interface cancelExchangeData {
  order_id: number;
  remark: string;
}
export const cancelExchangeApi = (data: cancelExchangeData) => {
  return service({
    url: "/api/v1/integral/exchange_order/cancel",
    method: "post",
    data,
  });
};

// 积分设置详情
export const getIntegralSettingApi = () => {
  return service({
    url: "/api/v1/integral/task/detail",
    method: "get",
  });
};
// 积分设置开关操作
export interface setIntegralTaskStatusData {
  task_key: string;
  status: number;
}
export const setIntegralTaskStatusApi = (data: setIntegralTaskStatusData) => {
  return service({
    url: "/api/v1/integral/task/modify_status",
    method: "post",
    data,
  });
};
// 积分设置任务分值保存
export interface saveTaskIntegralData {
  task_key: string;
  integral: number;
}
export const saveTaskIntegralApi = (data: saveTaskIntegralData) => {
  return service({
    url: "/api/v1/integral/task/modify_integral",
    method: "post",
    data,
  });
};
// 机构积分开关控制
export interface orgIntegralSwitchData {
  key: string;
  status: number;
}
export const orgIntegralSwitchApi = (data: orgIntegralSwitchData) => {
  return service({
    url: "/api/v1/org/config/switch_modify",
    method: "post",
    data,
  });
};
// 积分卡-列表
export interface getIntegralCardListData {
  page: number;
  page_size: number;
  card_name?: string;
}
export const getIntegralCardListApi = (params: getIntegralCardListData) => {
  return service({
    url: "/api/v1/integral/card/list",
    method: "get",
    params,
  });
};
// 积分卡-添加
export interface createIntegralCardData {
  card_name: string;
  integral: number;
  num: number;
  remark?: string;
}
export const createIntegralCardApi = (data: createIntegralCardData) => {
  return service({
    url: "/api/v1/integral/card/add",
    method: "post",
    data,
  });
};
// 积分记录-获取类型列表
export const getIntegralLogSourceApi = () => {
  return service({
    url: "/api/v1/integral/student/log_source",
    method: "get",
  });
};
// 积分记录-日志列表
export interface getIntegralLogListData {
  page: number;
  page_size: number;
  key_word?: number;
  source?: number;
  type?: number[];
  start_date?: string;
  end_date?: string;
}
export const getIntegralLogListApi = (data: getIntegralLogListData) => {
  return service({
    url: "/api/v1/integral/student/log_list",
    method: "post",
    data,
  });
};
//二维码-积分卡导出
export interface exportIntegralCardData {
  card_id: number;
}
export const exportIntegralCardApi = (params: exportIntegralCardData) => {
  return service({
    url: "api/v1/integral/card/export",
    method: "get",
    params,
  });
};
//积分记录列表导出
export interface exportIntegralLogData {
  key_word?: number;
  source?: string;
  type?: number;
  start_date?: string;
  end_date?: string;
}
export const exportIntegralLogApi = (params: exportIntegralLogData) => {
  return service({
    url: "/api/v1/integral/student/log_list_export",
    method: "get",
    params,
  });
};
